
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cooperation",
      function () {
        return require("private-next-pages/cooperation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cooperation"])
      });
    }
  